import { BrowserHttpError } from '../http/createBrowserHttpClient';

export function getGuestErrorMessage(error: unknown, fallback: string) {
  if (error instanceof BrowserHttpError || error instanceof Error) {
    return error.message;
  }

  return fallback;
}
